import { useEffect, useCallback } from 'react';
import { useMutation } from '@apollo/client';

import DeleteCheckbox from '../../../components/inputs/DeleteCheckbox';
import { currency } from '../../../utils';
import { useOrder, SET_ATTR, UPDATE_PRODUCTS } from '../../../hooks/useOrder';
import { REMOVE_FROM_ORDER } from '../../../mutations';
import ErrorText from '../../../components/ErrorText';
import { identifierAddOnIds } from './tabs';
import { getProduct } from '../../../helpers/products';
import { useAuth } from '../../../hooks/useAuth';

export default function AddOnItem({
  product,
  showDelete = true,
  showDiscount = true,
}) {
  const { state, dispatch } = useOrder();
  const { orderDetails, products } = state;
  const { orderId } = orderDetails;

  const { user } = useAuth();
  const plan = user?.plan;

  const { id, priceId, price, quantity } = product;

  const { id: identifierBundleAddOnId } = getProduct(
    'identifierBundleAddOn',
    plan
  );

  const [
    removeFromOrder,
    {
      loading: loadingRemoveFromOrder,
      error: errorRemoveFromOrder,
      data: dataRemoveFromOrder,
    },
  ] = useMutation(REMOVE_FROM_ORDER);

  useEffect(() => {
    dispatch({
      type: SET_ATTR,
      payload: {
        name: 'loadingRemoveFromOrder',
        value: loadingRemoveFromOrder,
      },
    });
  }, [dispatch, loadingRemoveFromOrder]);

  useEffect(() => {
    dispatch({
      type: SET_ATTR,
      payload: {
        name: 'errorRemoveFromOrder',
        value: errorRemoveFromOrder,
      },
    });
  }, [dispatch, errorRemoveFromOrder]);

  const handleRemoveClick = useCallback(() => {
    removeFromOrder({
      variables: {
        orderId,
        product: {
          id,
          priceId,
          quantity,
        },
      },
      onCompleted: (data) => {
        dispatch({
          type: UPDATE_PRODUCTS,
          payload: {
            lineItems: data?.removeFromOrder?.invoice?.lineItems,
            totalPrice: data?.removeFromOrder?.invoice?.total,
          },
        });
      },
    });
  }, [dispatch, orderId, priceId, id, quantity, removeFromOrder]);

  useEffect(() => {
    if (id !== identifierBundleAddOnId && identifierAddOnIds.includes(id)) {
      if (
        (!products.find(({ id }) => id === identifierBundleAddOnId) &&
          identifierAddOnIds.every((identifierAddOnId) =>
            products.find((p) => p.id === identifierAddOnId)
          )) ||
        (products.find(({ id }) => id === identifierBundleAddOnId) &&
          identifierAddOnIds.some((identifierAddOnId) =>
            products.find((p) => p.id === identifierAddOnId)
          ))
      ) {
        handleRemoveClick();
      }
    }
  }, [handleRemoveClick, identifierBundleAddOnId, id, products]);

  return (
    <>
      <div
        className={`relative flex flex-row py-1 w-full italic justify-between rounded-lg ${
          loadingRemoveFromOrder ? 'pointer-events-none' : ''
        }`}
      >
        {loadingRemoveFromOrder && (
          <div className="absolute -inset-2 z-50 opacity-90 animate-pulse rounded-half bg-gray-100"></div>
        )}
        <div className="flex flex-row">
          {showDelete && (
            <DeleteCheckbox
              className="mr-2 mt-1"
              height={4}
              width={4}
              onClick={handleRemoveClick}
            />
          )}
          <div className="flex flex-col mr-1">
            <p>{product?.productName}</p>
          </div>
        </div>
        <p className="not-italic">
          {' '}
          {product?.discount && showDiscount ? (
            <>
              <span className="line-through text-gray-400 mr-1">
                {currency(product?.amount)}
              </span>
              {currency(product?.amount - product?.discount)}
            </>
          ) : (
            currency(product?.amount)
          )}
        </p>
      </div>
      {errorRemoveFromOrder && (
        <ErrorText message={errorRemoveFromOrder?.message} />
      )}
    </>
  );
}
